import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab from '../../components/elements/Tab/Tab';
import TermConditionContent from './TermConditionContent';
import styles from './styles.scoped.css';

export default function TermCondition() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab') || 'pangkalan';

  const tabList = [
    { label: 'Pangkalan', value: 'pangkalan', info: '' },
    { label: 'Subpangkalan', value: 'subpangkalan' },
    { label: 'Pelanggan', value: 'pelanggan' },
  ];

  const handleChangeTab = (val) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('tab', val);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString()
    });
  };

  return (
    <div className={styles.root}>
      <Tab
        data={tabList}
        defaultValue={currentTab}
        onChange={handleChangeTab} />
      <TermConditionContent type={currentTab} />
    </div>
  );
}
